<template>
  <div class="template-wrapper" v-if="message.AttachmentFile.Payload && message.AttachmentFile.Payload.length > 0">
    <div class="payload-item" v-for="(payload, index) in message.AttachmentFile.Payload" :key="index">
      <div>
        <div class="website-info" v-if="payload.Favicon && payload.Domain">
          <img class="website-favicon" :src="payload.Favicon" v-if="payload.Favicon">
          <div class="website-domain" v-html="payload.Domain" v-if="payload.Domain"></div>
        </div>
        <a :href="payload.Uri" target="_blank">
          <div class="payload-title" v-html="payload.Title" v-if="payload.Title"></div>
        </a>
        <div v-html="payload.Description" v-if="payload.Description"></div>
        <div v-if="payload.VideoUrl || payload.ImageUrl" class="payload-media">
          <div v-if="payload.VideoUrl">
            <!-- <div class="payload-video-expand-btn" v-on:click="openFileViewer">
                                                                                                                        <i class="fa fa-arrows-alt"></i>&nbsp;Expand Video
                                                                                                                    </div> -->
            <iframe class="payload-video" frameborder="0" :src="payload.VideoUrl" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </div>
          <img v-if="payload.ImageUrl && !payload.VideoUrl" class="payload-image" :src="payload.ImageUrl" v-on:click="openFileViewer"
          />
          <!-- click: function(){ $parents[2].showImagePreview(payload.ImageUrl); } -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'urlPayload',
    data(){
      return {
        message: null
      }
    },
    props: [
        'openFileViewer'
    ],
    created(){
      let vm = this;
      vm.message = vm.$parent._props.message;
    }
  }

</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/components/Messenger/MessageList/Message/MessageAttachment/UrlPayload.vue